import React, { createContext, Component } from 'react'
import { Switch, Link, Route, Redirect } from 'react-router-dom'
import styled from 'styled-components'
import CriteriaForm from './CriteriaForm'
import EditPatientForm from './EditPatientForm'
import DiseasesForm from './DiseasesForm'
import CreateGoalsForm from '../../Goal/containers/CreateGoalsForm'

const Div = styled.div`
  display: grid;
  margin-top: 2rem;
  padding: 0 1rem;
  grid-template-columns: 20rem 1fr;
  grid-template-areas: 'aside main';
  & > nav {
    grid-area: aside;
  }
  & > form {
    grid-area: main;
    justify-self: center;
    width: 40rem;
  }
`

export const PatientContext = createContext()

class ContextProvider extends Component {
  state = {
    disease: null,
    isEligible: false
  }

  render() {
    return (
      <PatientContext.Provider
        value={{
          state: this.state,
          setPatientEligibility: isEligible =>
            this.setState({
              isEligible
            }),
          selectDisease: disease =>
            this.setState({
              disease
            })
        }}
      >
        {this.props.children}
      </PatientContext.Provider>
    )
  }
}

class AddPatientChannel extends React.Component {
  state = {
    error: false
  }
  componentDidCatch() {
    this.setState({
      error: true
    })
  }

  render = () => (
    <ContextProvider>
      <Div>
        <nav key="nav">
          <ul>
            <li>
              <Link to="/patients/add/step-1">pathologies</Link>
            </li>
            <li>
              <Link to="/patients/add/step-2">critères</Link>
            </li>
            <li>
              <Link to="/patients/add/step-3">informations</Link>
            </li>
            <li>
              <Link to="/patients/add/step-4">seuils</Link>
            </li>
          </ul>
        </nav>
        {this.state.error === false ? (
          <Switch key="main">
            <Route path="/patients/add/step-1" component={DiseasesForm} />
            <Route path="/patients/add/step-2" component={CriteriaForm} />
            <Route path="/patients/add/step-3" component={EditPatientForm} />
            <Route path="/patients/add/step-4" component={CreateGoalsForm} />
            <Redirect to="/patients/add/step-1" />
          </Switch>
        ) : (
          <span>Une erreur est survenue, veuillez recharger la page...</span>
        )}
      </Div>
    </ContextProvider>
  )
}

export default AddPatientChannel



// WEBPACK FOOTER //
// ./src/Patients/containers/AddPatientChannel.js